import {
  addThreatReviewCategory,
  deleteThreatReviewCategory,
  getThreatReviewCategories,
  updateThreatReviewCategory,
} from "@/services";
import { useMutation, useQuery } from "@tanstack/react-query";

export const THREAT_REVIEW_CATEGORIES_QUERY_KEY = ["threat-review-categories"] as const;

export function useThreatReviewCategories() {
  return useQuery({
    queryKey: THREAT_REVIEW_CATEGORIES_QUERY_KEY,
    queryFn: getThreatReviewCategories,
    throwOnError: true,
    staleTime: 0,
    gcTime: 0,
  });
}

export function useAddThreatReviewCategory() {
  return useMutation({
    mutationFn: async ({
      code,
      name,
      description,
    }: {
      code: string;
      name: string;
      description?: string;
    }) => addThreatReviewCategory({ code, name, description }),
  });
}

export function useUpdateThreatReviewCategory() {
  return useMutation({
    mutationFn: async ({
      categoryCode,
      name,
      description,
    }: {
      categoryCode: string;
      name: string;
      description?: string;
    }) => updateThreatReviewCategory({ categoryCode, name, description }),
  });
}

export function useDeleteThreatReviewCategory() {
  return useMutation({
    mutationFn: async ({ categoryCode }: { categoryCode: string }) =>
      deleteThreatReviewCategory({ categoryCode }),
  });
}
